/**
 * Moneda por Defecto
 */
export const DEFAULT_CURRENCY = 'ARS';